<!--  -->

<template>
  <div class="content">
    <header :class="chid_hover ? 'sticky' : ''">
      <div class="top">
        <!-- 导航 -->
        <div class="card">
          <img src="../../assets/img/index/logo.png" alt="暂无图片" v-if="!roll || !chid_hover" />
          <img src="../../assets/img/index/log.png" alt="暂无图片" v-if="roll || chid_hover" />

          <!-- pc导航 -->

          <nav>
            <ul class="nav_list">
              <li class="nav_item">
                <a class="a" href="#" @click="topUrl(0, '/')" :class="type == 0 ? 'active' : ''"
                  :style="roll ? 'color:#333' : ''">首页</a>
              </li>
              <li class="nav_item" id="serve" @mouseover="mouseoverOver"
              @mouseout="mouseoutOut"
              >
                <a href="#" class="a" :class="type == 1 ? 'active' : ''" :style="roll ? 'color:#333' : ''">产品
                  <span class="iconfont icon-next-copy ioc tops"></span>
                  <span class="iconfont icon-icon_arrow_top ioc dowm"></span>
                </a>
                <ul class="chid_serve">
                  <li class="chid_item" v-for="(item, index) in chid_list" :key="index"
                    @click="topUrl(1, item.url, item.id, item.a_url, item)">
                    <a href="#" class="a">
                      <div class="right">
                        <div class="text">{{ item.text }}</div>
                      </div>
                    </a>
                  </li>
                </ul>
              </li>
              <li class="nav_item">
                <a href="#" class="a" @click="topUrl(2, '/about')" :class="type == 2 ? 'active' : ''"
                  :style="roll ? 'color:#333' : ''">案例</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <!-- 背景层 -->
      <div class="bg"></div>
    </header>

    <div>
      <router-view />
    </div>
    <a id="d_jump">
      <Footer :index="$store.state.current" :a_url="a_url" :text="nav_current" :top_text="top_text"
        :fot_text="fot_text">
      </Footer>
    </a>
  </div>
</template>

<script>
import Footer from "../../components/footer";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    Footer,
  },
  data() {
    //这里存放数据
    return {
      chid_list: [
        {
          id: "关务管理系统实时掌握通关状态",
          text: "关务管理",
          url: "/Haotong",
          a_url: "https://www.sinoetrade.com/sh/index.php",
          top_text: "提交信息申请免费体验，体验无纸化通关数据管理平台",
          fot_text:
            "您提交的信息仅限于申请关务管理系统的免费体验资格，您的信息将会被严格保密！",
        },
        {
          id: "仓库管理系统解决仓储配送两大管理难题",
          text: "仓储配送",
          url: "/Storage",
          a_url: "https://www.sinoetrade.com/sh/index.php",
          top_text: "提交信息申请免费体验，体验仓储配送一体化管理",
          fot_text:
            "您提交的信息仅限于申请仓库管理系统的免费体验资格，您的信息将会被严格保密！",
        },
        {
          id: "货运管理系统提供一站式货运代理服务",
          text: "国际货代",
          url: "/forwarder",
          a_url: "https://www.sinoetrade.com/sh/index.php",
          top_text: "提交信息申请免费体验，体验一站式货运代理服务",
          fot_text:
            "您提交的信息仅限于申请货运管理系统的免费体验资格，您的信息将会被严格保密！",
        },
        {
          id: "货运教学平台能让学生快速掌握线上货物实操技能",
          text: "货运教学平台",
          url: "/Service_education",
          a_url: "https://www.sinoetrade.com/sh/index.php",
          top_text: "提交信息申请免费体验，体验真实案例货物运输线上实操功能",
          fot_text:
            "您提交的信息仅限于申请货运教学平台的免费体验资格，您的信息将会被严格保密！",
        },
        {
          id: "周期购电商系统锁定客户，提高客单价值",
          text: "周期购",
          url: "/Cycle ",
          a_url: "https://www.sinoetrade.com/sh/index.php",
          top_text: "提交信息申请免费体验，体验周期购模式商品管理平台",
          fot_text:
            "您提交的信息仅限于申请周期购电商系统的免费体验资格，您的信息将会被严格保密！",
        },
        {
          id: "跨境电商系统",
          text: "跨境电商",
          url: "/Shop",
          a_url: "https://www.sinoetrade.com/sh/index.php",
          top_text: "提交信息申请免费体验，体验智能数据核对",
          fot_text:
            "您提交的信息仅限于申请跨境电商系统的免费体验资格，您的信息将会被严格保密！",
        },

      ],
      // 子
      nav_current: "",
      a_url: "",
      top_text: "",
      fot_text: "",
      //学校
      current: 0,
      drawer: false,
      chid_show: false,
      roll: false, //滑动
      roll_true: false,
      chid_hover: false,
      //
      type: 0,
      mouser:false,

    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    mouseoverOver(){
      this.mouser=true;
    },
    mouseoutOut(){
      this.mouser=false;
    },
    //跳转
    topUrl(index, url, text, a_url, item) {
      this.$router.push(url);
      this.type = index;
      console.log("type", this.type);
      this.$store.state.current = index;
      this.drawer = false;
      this.current = index;
      localStorage.setItem("current", this.current);
      $(".chid_serve").hide();
      $(".bg").hide();
      window.sessionStorage.setItem('text', text)
      this.nav_current = window.sessionStorage.getItem('text');
      this.a_url = a_url;
      window.sessionStorage.setItem('top_text', item.top_text)
      this.top_text = window.sessionStorage.getItem('top_text');
      window.sessionStorage.setItem('fot_text', item.fot_text)
      this.fot_text = window.sessionStorage.getItem('fot_text');
    },
    handleClose() {
      this.$store.state.current = 1;
      this.chid_show = !this.chid_show;
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.type = localStorage.getItem('current')
    console.log('12', this.$route.path == '/')

    // localStorage.setItem("current", 0);
  },

  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    const headerEl = document.querySelector("header");
    // const scrollToTop = document.querySelector(".scroll-to-top");

    window.addEventListener("scroll", () => {
      // 获取
      let height = headerEl.getBoundingClientRect().height;

      if (window.pageYOffset - height > 20) {
        this.type = localStorage.getItem('current')
        if (!headerEl.classList.contains("sticky")) {
          headerEl.classList.add("sticky");
          this.roll = true;
          this.chid_hover = true;
          this.roll_true = true;
        }
      } else {
        headerEl.classList.remove("sticky");
        this.type = localStorage.getItem('current')
        this.roll = false;
        this.chid_hover = false;
        this.roll_true = false;
      }
      if (window.pageYOffset === 0 || document.documentElement.scrollTop === 0) {

        if (this.mouser) {
          if (!headerEl.classList.contains("sticky")) {
          headerEl.classList.add("sticky");
          this.roll = true;
          this.chid_hover = true;
          this.roll_true = true;
        }
        }

        console.log('已经滚动到页面顶部');
      }
    });
    //子菜单显示
    $(".chid_serve").hide();
    $(".bg").hide();
    $(".san_serve").hide();
    $(".dowm").hide();
    $("#serve").hover(
      () => {
        $(".chid_serve").show();
        $(".san_serve").show();
        $(".bg").show();
        $(".dowm").show();
        $(".tops").hide();

        this.chid_hover = true;
        this.roll = true;
      },
      () => {
        $(".chid_serve").hide();
        $(".san_serve").hide();
        $(".bg").hide();
        $(".tops").show();
        $(".dowm").hide();
        if (!this.roll_true) {
          this.chid_hover = false;
          this.roll = false;
        }
      }
    );
  },
  beforeCreate() {
    if (this.$route.path == "/") {
      localStorage.setItem("current", 0);

    }
  }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped lang="less">
@import url(../Home/pc);
@import url(../Home/mod);
</style>
